import React, { useEffect, useRef, useState } from 'react'
import styles from './calendarSchedule.module.css'

import { useNavigate } from "react-router-dom";
import cleanerOne from "../../../assets/cleanerOne.png";
import cleanerTwo from "../../../assets/cleanerTwo.png";
import plusIcon from "../../../assets/plusIcon.png";
import { DatePicker, List, Typography } from "antd";
import { AntdDropdown, SearchInput } from '../../../components';
import { useTranslation } from 'react-i18next';
import './override.css'
import { FaCalendarAlt } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import ScheduleMiddleware from '../../../store/Middlewares/ScheduleMiddleware';
import moment from 'moment';


const CalendarSchedules = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const timeout = useRef(null);



  const [search, setSearch] = useState('')

  const allSchedules = useSelector((state) => state.ScheduleReducer.AllScheduleList)
  const allScheduleListPagination = useSelector(state => state.ScheduleReducer.AllScheduleListPagination)
  console.log(allScheduleListPagination);

  useEffect(() => {
    getSchedules();
  }, [])



  const getSchedules = () => {
    let data = {
      search: search,
      next_page_url: undefined,
    }
    dispatch(ScheduleMiddleware.getAllSchedule(data))

  }

  const onPressLoadMore = () => {
    let data = {
      search: search,
      next_page_url: allScheduleListPagination?.links?.next,
    };
    dispatch(ScheduleMiddleware.getAllSchedule(data));
  };


  const onSearchPastSchedule = (text) => {
    let data = {
      search: text,
      next_page_url: undefined,
    }
    setSearch(text);
    clearTimeout(timeout.current)
    timeout.current = setTimeout(() => {
      dispatch(ScheduleMiddleware.getAllSchedule(data))
    }, 1000);
  }


  const { t } = useTranslation();
  const { Text } = Typography;

  const data = new Array(4).fill({
    id: 1,
    date: "06-29-2023",
    customerName: "Mr. James",
    cleanerName: "Jason Smith",
    category: 'Custodial Engineer',
    TimeIn: "10:00 AM",
    TimeOut: "5:00 PM",
    Hours: "5 Hr 30 Min",
    Location: '8675, New York City',
    BHours: '1 Hour'
  })

  const handleChange = value => {
    // console.log(value);
  };

  const loadMore =
    allScheduleListPagination?.links?.next ? (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
          display: 'flex', justifyContent: 'center'
        }}
      >
        <button onClick={onPressLoadMore} className={styles.loadMore_button}>
          Load More
        </button>
      </div>
    ) : null;
  return (
    <div className={styles.home_mainContainer}>
      <h1 className={styles.heading}>{t("Schedule")}</h1>
      <div className={styles.mainContainer}>
        <div className={styles.filterCont}>
          <div className={styles.filterItem}>
            <SearchInput onChange={(e) => onSearchPastSchedule(e.target.value)} placeholder={"Search"} style={{ width: '100%' }} />
          </div>
        </div>
        <List
          grid={{
            gutter: 16,
            //   xs: 2,
            sm: 1,
            md: 1,
            lg: 2,
            xl: 2,
            xxl: 3,
          }}
          // className={styles.createChecklist_list}
          dataSource={allSchedules}
          footer={loadMore}
          style={{ width: '100%' }}
          renderItem={(item) => (
            console.log('item', item),
            <>
              <div className={styles.content}>
                <div className={styles.MainCont}>
                  <div className={styles.Date}>
                    <div>
                      <Text className={styles.headintext}>{moment(item?.date).format('Do')}</Text>
                    </div>
                    <div>
                      <Text style={{ color: 'white' }}>{moment(item?.date).format('dddd')}</Text>
                    </div>
                  </div>
                  <div className={styles.deatilCont} >
                    <div>
                      <Text className={styles.headintext}>{item?.cleaner_name}</Text>
                    </div>
                    <div>
                      <Text className={styles.headintext}>{
                        moment('01 jan 1940 ' + item?.start_time).format('hh:mm A') +
                        ' To ' +
                        moment('01 jan 1940 ' + item?.end_time).format('hh:mm A')
                      }</Text>
                    </div>
                    <div>
                      <Text className={styles.headintext}>{item?.location?.state}</Text>
                    </div>
                    <div>
                      <Text className={styles.text}>{item?.location?.address}</Text>
                    </div>
                  </div>
                </div>
                {/* <Text style={{ color: 'white', fontSize: 25, fontWeight: 'bold', color: 'var(--secondary-color)' }}>Room Cleaning</Text> */}
                <Text className={styles.text}>{item?.details}</Text>
              </div>
            </>
          )}
        />
      </div>
    </div>
  );
};


export default CalendarSchedules